import { create } from "zustand";

interface HelpUploadsState {
	/** Signed links to the images uploaded in this tab, by id. */
	urls: Record<string, string>;
	remember: (id: string, url: string) => void;
}

/**
 * Images uploaded in this tab, so a draft's preview can show them before the
 * content is saved: the server only gives links (`GET /api/help-centre/assets`)
 * for saved content. Like the server's, these links expire after an hour or
 * two.
 */
export const useHelpUploadsStore = create<HelpUploadsState>((set) => ({
	urls: {},
	remember: (id, url) =>
		set((state) => ({ urls: { ...state.urls, [id]: url } })),
}));
